var _rect, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWifi(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 68,
    height: 69,
    viewBox: "0 0 68 69",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.695312,
    width: 68,
    height: 68,
    rx: 16,
    fill: "#F4F8FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.5352 37.3179C30.6211 32.4722 37.4291 32.4722 42.5151 37.3179",
    stroke: "#66AFFF",
    strokeWidth: 8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M51 28.8286C48.8375 26.7061 46.4347 25.0642 43.9518 23.8628C37.5843 20.8192 30.4559 20.8192 24.0483 23.8628C21.5654 25.0642 19.2026 26.7061 17 28.8286",
    stroke: "#66AFFF",
    strokeWidth: 8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M34 47.8105H34.0377",
    stroke: "#66AFFF",
    strokeWidth: 8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWifi);
export default __webpack_public_path__ + "static/media/wifi.b7294cc16e13ab4db83365fe5305ae21.svg";
export { ForwardRef as ReactComponent };